export const projectStatusEnum = [
  { id: "Open", name: "Open" },
  { id: "Closed", name: "Closed" },
];

export const defaultFilterProjectStatus = "Open";
